module.exports = __webpack_public_path__ + "img/Fachadacontacto.6d5e413d.jpg";